namespace $.$$ {
	$mol_style_define( $shm_projects_timeline, {
		flex: { grow: 1, shrink: 1, basis: 0, direction: 'column' },
		gap: $mol_gap.text,
		width: '100%',
		height: '100%',
		minWidth: 0,
		overflow: 'hidden',

		Timeline_head: {
			alignItems: 'center',
			justifyContent: 'flex-start',
			gap: $mol_gap.text,
			padding: $mol_gap.text,
		},

		Timeline_title: {
			font: { size: '1.1rem', weight: 'bold' },
		},

		Week_select: {
			flex: { grow: 0, shrink: 1, basis: '20rem' },
			minWidth: '12rem',
		},

		Timeline_content: {
			flex: { grow: 1, shrink: 1, basis: 0 },
			gap: $mol_gap.block,
			minHeight: 0,
			alignItems: 'stretch',
			overflowX: 'auto',
			overflowY: 'hidden',
		},

		Timeline_days: {
			display: 'grid',
			gridTemplateColumns: 'repeat(7, minmax(360px, 1fr))',
			gap: $mol_gap.text,
			flex: { grow: 1, shrink: 0, basis: '56rem' },
			minWidth: 'min-content',
			minHeight: 0,
			height: '100%',
			alignItems: 'start',
		},

		Week_summary: {
			flex: { grow: 0, shrink: 0, basis: '36rem' },
			minHeight: 0,
			overflowY: 'auto',
			border: { width: '1px', style: 'solid', color: $mol_theme.line, radius: $mol_gap.round },
			background: { color: $mol_theme.card },
		},

		Day_summary: {
			':empty': { display: 'none' },
		},

		Timeline_day: {
			flex: { direction: 'column' },
			gap: $mol_gap.text,
			minWidth: '360px',
			minHeight: '6rem',
			maxHeight: '100%',
			overflowY: 'auto',
			border: { width: '1px', style: 'solid', color: $mol_theme.line, radius: $mol_gap.round },
			background: { color: $mol_theme.card },
			'[today]': {
				true: {
					border: { color: $mol_theme.text },
				},
			},
		},

		Timeline_day_title: {
			padding: $mol_gap.text,
			color: $mol_theme.shade,
			font: { size: '1.25rem', weight: 'bold' },
			'[today]': {
				true: { color: $mol_theme.text },
			},
		},

		Timeline_events: {
			flex: { direction: 'column' },
			gap: $mol_gap.text,
		},

		Timeline_event: {
			justifyContent: 'flex-start',
			padding: $mol_gap.text,
			whiteSpace: 'normal',
			overflowWrap: 'anywhere',
		},

		Timeline_empty: {
			padding: $mol_gap.text,
			color: $mol_theme.shade,
		},
	} )
	$mol_style_attach( '$shm_projects_timeline_auto_height', `
		[shm_hitalama_map_widget_float][auto_height]:not([fullscreen]) [shm_projects_timeline] {
			height: 300px;
			flex-basis: 300px;
			contain: layout paint;
		}
	` )
}
